import { JSX } from "@emotion/react/jsx-runtime";
import { ReactNode } from "react";
import { Typography } from "@mui/material";
import { DynamicContentImage } from "../DynamicContentComponent";
import { ImageComponent } from "../ImageComponent";
import { Features, isEnabled } from "../../utils/featureToggle";
import environment from "../../utils/environment";
import { getFullUrl } from "../../utils/paths";

export const DynamicImage = ({ imageSrc, imageProps, variant, key, childElements }: DynamicContentImage): JSX.Element => {
    // Determine full url - e.g for CDN usage
    imageSrc = getFullUrl(imageSrc) as string;
    if (variant) {
      return (
        <ImageComponent 
          variant={variant}
          imageSrc={imageSrc}
          imageProps={imageProps}
          key={key}
        >
          {childElements || ''}
        </ImageComponent>  
      )
    }
    return (
      <ImageComponent
        imageSrc={imageSrc}
        imageProps={imageProps}
        key={key}
      >
        {childElements || ''}
      </ImageComponent> 
    )
}